import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Box,
    TextField,
    Button,
    Typography,
    Checkbox,
    FormControlLabel,
    Grid,
} from '@mui/material';
import { createEvaluation } from '../services/propertyService';
import { Pageheader } from './global-components/page-header';
import bgImage from '../assets/img/newimgaes/Property Services.jpeg';
import Toast from "../components/Toast"

const FreeValuationForm = (props) => {
    const [toastOpen, setToastOpen] = React.useState(false);
    const [toastMessage, setToastMessage] = React.useState("");
    const validationSchema = Yup.object({
        firstname: Yup.string().required('First name is required'),
        number: Yup.string()
            .matches(/^(?:\+91|0)?[6-9]\d{9}$/, "Invalid Indian mobile number")
            .required('Contact number is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        postcode: Yup.string().required('Postcode is required'),
        streetAddress: Yup.string().required('Street address is required'),
        message: Yup.string().required('Message is required'),
        terms: Yup.boolean().oneOf(
            [true],
            'You must accept the terms and conditions'
        ),
    });

    const formik = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            number: '',
            email: '',
            postcode: '',
            streetAddress: '',
            message: '',
            salesValuation: false,
            lettingsValuation: false,
            newsUpdates: false,
            terms: false,
        },
        validationSchema,
        onSubmit: (values) => {
            createEvaluation(values)
                .then((res) => {
                    console.log('Response:', res);
                    setToastMessage(res.message);
                    setToastOpen(true);
                    setTimeout(() => {
                        props.onClose && props.onClose(false);
                    }, 2000);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    setToastMessage("There was an error submitting the form. Please try again.");
                    setToastOpen(true);
                });
        }

    });

    return (
        <>
            {props.isPage && (
                <Pageheader headertitle="Book A Free Valuation" bgImage={bgImage} />
            )}
            <Box className="container p-4">
                <Typography variant="h4" textAlign="center" marginBottom={2}>
                    {props.isContactForm ? "Contact Us" : "Book a Free Valuation"}
                </Typography>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="firstname"
                                name="firstname"
                                placeholder="First Name"
                                value={formik.values.firstname}
                                onChange={formik.handleChange}
                                error={formik.touched.firstname && Boolean(formik.errors.firstname)}
                                helperText={formik.touched.firstname && formik.errors.firstname}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="lastname"
                                name="lastname"
                                placeholder="Last Name"
                                value={formik.values.lastname}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="number"
                                name="number"
                                placeholder="Contact Number"
                                value={formik.values.number}
                                onChange={formik.handleChange}
                                error={formik.touched.number && Boolean(formik.errors.number)}
                                helperText={formik.touched.number && formik.errors.number}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="email"
                                name="email"
                                placeholder="Email Address"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="streetAddress"
                                name="streetAddress"
                                placeholder="Street Address"
                                value={formik.values.streetAddress}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.streetAddress &&
                                    Boolean(formik.errors.streetAddress)
                                }
                                helperText={
                                    formik.touched.streetAddress && formik.errors.streetAddress
                                }
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="postcode"
                                name="postcode"
                                placeholder="Postcode"
                                value={formik.values.postcode}
                                onChange={formik.handleChange}
                                error={formik.touched.postcode && Boolean(formik.errors.postcode)}
                                helperText={formik.touched.postcode && formik.errors.postcode}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="message"
                                name="message"
                                placeholder="Message"
                                multiline
                                rows={4}
                                value={formik.values.message}
                                onChange={formik.handleChange}
                                error={formik.touched.message && Boolean(formik.errors.message)}
                                helperText={formik.touched.message && formik.errors.message}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id="salesValuation"
                                        name="salesValuation"
                                        checked={formik.values.salesValuation}
                                        onChange={formik.handleChange}
                                    />
                                }
                                label="Sales Valuation"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id="lettingsValuation"
                                        name="lettingsValuation"
                                        checked={formik.values.lettingsValuation}
                                        onChange={formik.handleChange}
                                    />
                                }
                                label="Lettings Valuation"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id="newsUpdates"
                                        name="newsUpdates"
                                        checked={formik.values.newsUpdates}
                                        onChange={formik.handleChange}
                                    />
                                }
                                label="Get emails with the latest news on the local property market, our products and services."
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id="terms"
                                        name="terms"
                                        checked={formik.values.terms}
                                        onChange={formik.handleChange}
                                        color="primary"
                                    />
                                }
                                label="I have read and agree to the Terms and Conditions, Privacy Policy and Cookies Policy."
                            />
                            {formik.touched.terms && formik.errors.terms && (
                                <Typography color="error" variant="body2">
                                    {formik.errors.terms}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{
                            marginTop: 2,
                            backgroundColor: '#d8b035',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#c5a02f',
                            },
                            '@media (max-width: 600px)': {
                                fontSize: '1rem',
                            },
                        }}
                    >
                        Submit
                    </Button>
                </form>
            </Box>
            <Toast
                open={toastOpen}
                message={toastMessage}
                onClose={() => setToastOpen(false)}
                severity={toastMessage.includes('success') ? "success" : "error"}
                autoHideDuration={6000}
            />

        </>
    );
};

export default FreeValuationForm;
